import { render, staticRenderFns } from "./AddDiscount.vue?vue&type=template&id=1e5ab9ac&scoped=true&"
import script from "./AddDiscount.vue?vue&type=script&lang=ts&"
export * from "./AddDiscount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5ab9ac",
  null
  
)

export default component.exports